import * as localForage from 'localforage';
import * as uuid from 'uuid';

export const STORETIMEOUT = 600000;
const store = uuid.v4();
localForage.config({
	driver: [localForage.INDEXEDDB, localForage.WEBSQL],
	name: `vQuipOS`,
	version: 1.0,
	size: 4980736,
	storeName: `vquipOs_store`,
	description: 'vQuip Store',
});
